import { FC } from "react";
import {
  Button,
  Form,
  Input,
  Modal,
  Row,
} from "antd";
import { useTranslation } from "react-i18next";

interface QuotationFormProps {
  onConfirm: (values: PwdFormField) => void;
  onCancel: () => void;
}

export type PwdFormField = {
  password: string;
  password2: string;
}

const UpdateSupplierPwd: FC<QuotationFormProps> = ({
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation();

  const [form] = Form.useForm<PwdFormField>();


  return (
    <Modal title={t('supplierLayout.editPwd')} maskClosable={false} getContainer={false} open={true} onCancel={onCancel} footer={false} destroyOnClose>
      <Form<PwdFormField> form={form} onFinish={onConfirm}>
        <Form.Item label={t('member.pwd')} name='password' required rules={[{ required: true, message: t('member.enterPwd') }, { min: 6, message: t('member.pwdMinLength') }]}>
          <Input.Password placeholder={t('member.enterPwd')} />
        </Form.Item>
        <Form.Item label={t('member.confirmPwd')} name='password2' required rules={[
          { required: true, message: t('member.plConfirmPwd') },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue('password') === value) {
                return Promise.resolve();
              }
              return Promise.reject(new Error(t('member.pwdDiff')));
            },
          }),
        ]}>
          <Input.Password placeholder={t('member.reenterPwd')} />
        </Form.Item>
        <Row justify="end">
          <Button loading={false} type="default" onClick={onCancel} style={{ marginRight: '20px' }}>
            {t('common.cancel')}
          </Button>
          <Button loading={false} type="primary" onClick={() => form.submit()}>
            {t('member.sure')}
          </Button>
        </Row>
      </Form>
    </Modal>
  );
};

export default UpdateSupplierPwd;
